/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import { weekDaySchema } from './week-day-schema';

export const streakSchema = z.object({
  current: z.number(),
  max: z.number(),
  totalActiveDays: z.number(),
  todayTried: z.number(),
  weekDays: z.array(weekDaySchema),
});

export type IStreak = z.infer<typeof streakSchema>;
